<template>
  <div class="timetable">
    <div class="content-wrapper">
      <div class="schedule-wrapper">
        <el-tabs type="card" v-model="selectTab" @tab-click="handleClick" class="nav-hooker">
          <el-tab-pane label="试听课" name="1"></el-tab-pane>
          <el-tab-pane label="正式课" name="0"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="list-wrapper">
        <template v-if="list.length">
          <div class="list-item" v-for="(item,index) in list">
            <div class="item-top">
              <img class="lesson-img" :src="imgprefix+item.lessonfaceimg" width="182" height="124" alt="课程图片">
              <div class="classinfo-wrapper">
                <h2 class="lesson-title">{{decodeURIComponent(item.lessonname)}}</h2>
                <p v-if="item.democlass=='1'" class="row">学生姓名:{{decodeURIComponent(item.studentname)}}</p>
                <p class="row">班级:{{decodeURIComponent(item.classmodename)}}_{{decodeURIComponent(item.classname)}}</p>
              </div>
            </div>
            <div class="item-middle">
              <span class="item-middle-year">{{item.planstarttime.substring(0,10)}}</span><span
              class="item-middle-month">{{item.planstarttime.substring(11,16)}}-{{item.planendtime.substring(11,16)}}</span><span
              class="item-middle-catalogname">{{decodeURIComponent(item.catalogname)}}</span><span
              class="item-middle-edit" @click="showCatalogName(item,index)"></span>
              <button class="item-middle-btn" :class="{show:item.show}" @click="showChangeTime(item,index)">修改时间
              </button>
            </div>
            <slide-up-down ref="slideupdown" :active="item.show" :duration="500">
              <template v-if="item.showSingle">
                <div class="item-bottom">
                <span class="item-bottom-switch-text" v-if="item.democlass==0"
                      @click="switchModify(item,false)">批量时间修改</span>
                  <div class="item-bottom-table-wrapper" v-if="item.showSingle">
                    <h2 class="item-bottom-table-title">单个时间修改</h2>
                    <p class="item-bottom-table-free-row">
                      <span class="left">开课日期:</span>
                      <span class="right">
                  <el-date-picker
                    v-model="startDateValue"
                    type="date"
                    placeholder="选择日期"
                    :picker-options="pickerOptions"
                    size="small"></el-date-picker>
                </span>
                    </p>
                    <div class="item-bottom-table-free-row">
                      <span class="left">开始时间:</span>
                      <div class="right">
                        <el-time-picker
                          v-model="timeValue"
                          :format="'HH:mm'"
                          size="small"
                          placeholder="输入时间">
                        </el-time-picker>
                      </div>
                    </div>
                    <div class="item-bottom-table-free-row">
                      <span class="left">上课时长:</span>
                      <p class="select-week" @click="showModifyTime">
                        <template v-if="timeNumber==0">加减计算总时长</template>
                        <span class="weektext" v-else>{{timeNumber}}</span>
                      </p>
                      <div class="time-select-wrapper" v-if="timeShow">
                        <div class="modify-number-wrapper">
                          <span class="modify-number-icon minus" @click="minusNumber(5)"></span>
                          <span class="modify-number-number">5</span>
                          <span class="modify-number-icon add" @click="addNumber(5)"></span>
                        </div>
                        <div class="modify-number-wrapper">
                          <span class="modify-number-icon minus" @click="minusNumber(30)"></span>
                          <span class="modify-number-number">30</span>
                          <span class="modify-number-icon add" @click="addNumber(30)"></span>
                        </div>
                        <div class="result-number-wrapper">
                          <span class="result-number-text">总时长</span>
                          <span class="result-number-num">{{timeNumberOld}}</span>
                          <span class="result-number-text">分钟</span>
                        </div>
                        <div class="modify-number-btn-wrapper">
                          <button class="modify-number-btn cancel" @click="timeShow=false">取消</button>
                          <button class="modify-number-btn confirm" @click="confirmModifyTime">确定</button>
                        </div>
                      </div>
                    </div>
                    <div class="operate-btn-wrapper">
                      <button class="btn cancel" @click="item.show=false">取消</button>
                      <button class="btn confirm" @click="modifyClassTime(true)">修改</button>
                    </div>
                  </div>
                </div>
                <template v-if="selectTab=='1'">
                  <p class="item-hint">注释:当前因为是<span class="color">试听课</span>，并非正式课，所以课程修改时间次数<span
                    class="color">仅可修改2次</span>，超过2次将不可修改时间，如有问题，请<span class="color">联系客服！</span></p>
                </template>
                <template v-else>
                  <p class="item-hint">注释:修改时间您可以选择单个/整体修改，<span class="color">单个修改时间</span>-单独修改该课程的当前时间；<span
                    class="color">整体修改时间</span>，-把后续上课时间调整为该时间段</p>
                </template>

              </template>
              <template v-else>
                <div class="item-bottom">
                  <span class="item-bottom-switch-text" @click="switchModify(item,true)">单个时间修改</span>
                  <div class="item-bottom-table-wrapper">
                    <h2 class="item-bottom-table-title">批量时间修改</h2>
                    <div class="item-bottom-table-free-row">
                      <span class="left">课程周期:</span>
                      <p class="select-week" @click="showWeek">
                        <template v-if="weekText==''">请选择适合自己的周期</template>
                        <span class="weektext" v-else>{{weekText}}</span>
                      </p>
                      <div class="week-select-wrapper" v-if="weekShow">
                        <template v-for="(item,index) in weekList">
                        <span class="week-item" :class="{'now':item.show}"
                              @click="item.show=!item.show">{{item.name}}</span>
                        </template>
                        <div class="week-btn-wrapper">
                          <button class="week-confirm" @click="confirmWeek">确定</button>
                          <button class="week-cancel" @click="weekShow=false">取消</button>
                        </div>
                      </div>
                    </div>
                    <p class="item-bottom-table-free-row">
                      <span class="left">开课日期:</span>
                      <span class="right">
                  <el-date-picker
                    v-model="startDateValue"
                    type="date"
                    placeholder="选择日期"
                    :picker-options="pickerOptions"
                    size="small"></el-date-picker>
                </span>
                    </p>
                    <div class="item-bottom-table-free-row">
                      <span class="left">开始时间:</span>
                      <div class="right">
                        <el-time-picker
                          v-model="timeValue"
                          :format="'HH:mm'"
                          size="small"
                          placeholder="输入时间">
                        </el-time-picker>
                      </div>
                    </div>
                    <div class="item-bottom-table-free-row">
                      <span class="left">上课时长:</span>
                      <p class="select-week" @click="showModifyTime">
                        <template v-if="timeNumber==0">加减计算总时长</template>
                        <span class="weektext" v-else>{{timeNumber}}</span>
                      </p>
                      <div class="time-select-wrapper" v-if="timeShow">
                        <div class="modify-number-wrapper">
                          <span class="modify-number-icon minus" @click="minusNumber(5)"></span>
                          <span class="modify-number-number">5</span>
                          <span class="modify-number-icon add" @click="addNumber(5)"></span>
                        </div>
                        <div class="modify-number-wrapper">
                          <span class="modify-number-icon minus" @click="minusNumber(30)"></span>
                          <span class="modify-number-number">30</span>
                          <span class="modify-number-icon add" @click="addNumber(30)"></span>
                        </div>
                        <div class="result-number-wrapper">
                          <span class="result-number-text">总时长</span>
                          <span class="result-number-num">{{timeNumberOld}}</span>
                          <span class="result-number-text">分钟</span>
                        </div>
                        <div class="modify-number-btn-wrapper">
                          <button class="modify-number-btn cancel" @click="timeShow=false">取消</button>
                          <button class="modify-number-btn confirm" @click="confirmModifyTime">确定</button>
                        </div>
                      </div>
                    </div>
                    <div class="operate-btn-wrapper">
                      <button class="btn cancel" @click="item.show=false">取消</button>
                      <button class="btn confirm" @click="modifyClassTime(false)">修改</button>
                    </div>
                  </div>
                </div>
                <template v-if="selectTab=='1'">
                  <p class="item-hint">注释:当前因为是<span class="color">试听课</span>，并非正式课，所以课程修改时间次数<span
                    class="color">仅可修改2次</span>，超过2次将不可修改时间，如有问题，请<span class="color">联系客服！</span></p>
                </template>
                <template v-else>
                  <p class="item-hint">注释:修改时间您可以选择单个/整体修改，<span class="color">单个修改时间</span>-单独修改该课程的当前时间；<span
                    class="color">整体修改时间</span>，-把后续上课时间调整为该时间段</p>
                </template>
              </template>
            </slide-up-down>

          </div>
        </template>
        <template v-else>
          <div class="empty-wrapper">
            <img src="./noresult.png" alt="没有结果" width="290" height="164">
            <template v-if="selectTab=='1'">
              <router-link tag="div" to="/console/confirm/class" class="empty-hint-text free">~请前往试听确认~</router-link>
            </template>
            <template v-else>
              <p class="empty-hint-text">~暂无待上的课程~</p>
            </template>

          </div>
        </template>
      </div>

    </div>
    <el-dialog :visible.sync="nameShow" title="修改目录">
      <el-input v-model="catalogname" placeholder="请输入内容"></el-input>
      <section style="padding-top:40px;">
        <el-button @click="nameShow = false">取 消</el-button>
        <el-button type="primary" @click="confirmChangeCatalogName">确 定</el-button>
      </section>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import {toMinutes} from 'common/js/toMinutes.js';

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        //-----------以下内容和筛选有关-----------//
        selectTab: '0',
        //-----------以下内容和课程表有关-----------//
        list: [],
        //-----------以下内容和修改目录名有关-----------//
        nameShow: false,
        catalogname: null,
        itemNow: null,
        indexNow: 0,
        //-----------以下内容和修改试听班时间有关-----------//
        startDateValue: null,         //开课日期
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < (Date.now() - 3600 * 24 * 1000);
          }
        },
        timeValue: null,
        //-----------以下内容和修改收费班时间有关-----------//
        weekList: [
          {value: '0', name: '周日', show: false},
          {value: '1', name: '周一', show: false},
          {value: '2', name: '周二', show: false},
          {value: '3', name: '周三', show: false},
          {value: '4', name: '周四', show: false},
          {value: '5', name: '周五', show: false},
          {value: '6', name: '周六', show: false},
        ],
        weekShow: false,
        weekText: '',
        classcycle: '',
        timeNumber: 0,      //时长时间
        timeNumberOld: 0,
        timeShow: false,
      }
    },
    methods: {
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      //修改目录名称
      showCatalogName(item, index) {
        this.index = index;
        this.itemNow = item;
        this.catalogname = decodeURIComponent(item.catalogname);
        if(item.democlass==='0'){
          this.catalog_index=item.catalog_index;
        }
        this.nameShow = true;
      },
      confirmChangeCatalogName() {
        let params={
          c: 'ClassCatalog',
          a: 'UpdateClassCatalog',
          id: this.id,
          rid: this.schoolNow.rid,                //网校id
          catalogid: this.itemNow.classcatalogid,         //目录id
          catalogname: this.catalogname,
        };
        if(this.selectTab=='0'){
          params.catalog_index=this.catalog_index
        }

        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.$message({
              message: '修改目录成功',
              type: 'success'
            });
            response.obj.show = false;
            response.obj.showSingle = true;
            this.list[this.index] = response.obj;
            this.nameShow = false;
          }
        }).catch((err) => {

        })
      },
      //修改目录时间
      showChangeTime(item, index) {
        this.indexNow = index;
        //如果当前列表处于关闭状态
        if (item.show == false) {
          this.list.forEach(function (item) {
            item.show = false;
          });
        }
        item.show = !item.show;
        this.weekShow = false;
        this.timeShow = false;
        this.weekText = '';
        this.classcycle = '';
        this.startDateValue = null; //重置开课日期
        this.timeValue = new Date(item.planstarttime);    //重置开课时间
        this.timeNumberOld = 0;
        let classendtime=item.planendtime.substring(11,16);
        let classstarttime=item.planstarttime.substring(11,16);
        this.timeNumber = toMinutes(classendtime)-toMinutes(classstarttime);
        this.itemNow = item;
      },
      switchModify(item, boolean) {
        item.showSingle = boolean;
        this.$nextTick(() => {
          this.$refs.slideupdown[0].layout();
        })

      },
      getStartDate(time) {
        let startmonth = "0" + (time.getMonth() + 1);
        let startday = "0" + time.getDate();

        return time.getFullYear() + '-' + startmonth.substring(startmonth.length - 2) + '-' + startday.substring(startday.length - 2);
      },
      getStartEndTime(start, interval) {
        let startHour = "0" + start.getHours();
        let startMinutes = "0" + start.getMinutes();
        let starttime = startHour.substring(startHour.length - 2) + ':' + startMinutes.substring(startMinutes.length - 2);
        let totalMinutes = parseInt(startHour) * 60 + parseInt(startMinutes) + interval;
        let endHour = "0" + parseInt(totalMinutes / 60);
        let endMinute = "0" + totalMinutes % 60;
        let endtime = endHour.substring(endHour.length - 2) + ':' + endMinute.substring(endMinute.length - 2);
        return {
          starttime,
          endtime
        };
      },
      modifyClassTime(isSingle) {
        //对于收费课
        if (!isSingle) {
          if (this.classcycle === '') {
            this.$message({
              message: '请选择课程周期',
              type: 'warning'
            });
            return;
          }
        }
        if (this.startDateValue === null) {
          this.$message({
            message: '请选择开课日期',
            type: 'warning'
          });
          return;
        }
        if (this.timeValue === null) {
          this.$message({
            message: '请选择开始时间',
            type: 'warning'
          });
          return;
        }
        if (this.timeNumber === 0) {
          this.$message({
            message: '请设置上课时间',
            type: 'warning'
          });
          return;
        }
        let startHour = this.timeValue.getHours();
        let startMinutes = this.timeValue.getMinutes();
        let totalMinutes = startHour * 60 + startMinutes + this.timeNumber;
        // console.log(totalMinutes)
        if (totalMinutes > 24 * 60) {
          this.$message({
            message: '请缩短上课时长或将开课时间往前调整，确保上课时间段在一天之内',
            type: 'warning'
          });
          return;
        }
        let startDate = this.getStartDate(this.startDateValue);
        // console.log(startDate)
        let {starttime, endtime} = this.getStartEndTime(this.timeValue, this.timeNumber);
        // console.log(starttime)
        // console.log(endtime)
        let params = {
          c: 'ClassCatalog',
          a: 'UpdateModifyClassCatalog',
          id: this.id,
          rid: this.itemNow.rid,
          classid: this.itemNow.classid,
          catalog_index: this.itemNow.catalog_index,
          startdate: startDate,
          starttime: starttime,
          endtime: endtime,
        };
        //如果是收费课
        if (!isSingle) {
          params.classcycle = this.classcycle;
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.$message({
              message: '修改目录成功',
              type: 'success'
            });
            response.obj.show = false;
            response.obj.showSingle = true;
            this.list[this.indexNow] = response.obj;
            this.$forceUpdate();
          } else {
            this.$message({
              message: response.msg,
              type: 'warning',
            });
          }
        }).catch((err) => {
          console.log(err)
        });
      },
      //显示周几
      showWeek() {
        let weekNow = this.classcycle.split(',');
        this.weekList.forEach(function (item) {
          item.show = false;
        });
        for (let i = 0; i < weekNow.length; i++) {
          for (let j = 0; j < this.weekList.length; j++) {
            if (this.weekList[j].value === weekNow[i]) {
              this.weekList[j].show = true;
            }
          }
        }
        this.weekShow = true;
      },
      //确认课程周期
      confirmWeek() {
        //计算课程周期返回的字段
        let weekText = '',
          classcycle = [];
        for (let i = 0; i < this.weekList.length; i++) {
          if (this.weekList[i].show == true) {
            weekText += this.weekList[i].name + ' ';
            classcycle.push(this.weekList[i].value);
          }
        }
        this.weekText = weekText;
        this.classcycle = classcycle.join(",");
        this.weekShow = false;
      },
      //显示选择时长
      showModifyTime() {
        this.timeNumberOld = this.timeNumber;
        this.timeShow = true;
      },
      minusNumber(num) {
        let temNum = this.timeNumberOld - num;
        if (temNum >= 0) {
          this.timeNumberOld = temNum;
        }
      },
      addNumber(num) {
        this.timeNumberOld += num;
      },
      confirmModifyTime() {
        this.timeNumber = this.timeNumberOld;
        this.timeShow = false;
      },
      //根据用户选择的选项，计算XHR请求的参数
      conputeXHRParams(pageNumber) {
        let params = {
          c: 'Lesson',
          a: 'QueryModifyClassCatalog',
          id: this.id,                //sessionid
          rid: this.schoolNow.rid,
          pageno: pageNumber,
          pagesize: 10
        };
        //对应后台，1为试听课，0为收费课
        if (this.selectTab === '1') {
          params.democlass = 1;
        } else if (this.selectTab === '0') {
          params.democlass = 0;
        }
        return params;
      },
      //获取课程表列表
      loadList(params) {
        this.list = [];
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let list = response.list;
            for (let i = 0; i < list.length; i++) {
              list[i].show = false;     //用于控制修改时间的显示隐藏
              list[i].showSingle = true;  //用于控制显示的是修改单个时间还是批量修改时间
            }
            this.list = list;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      handleClick(tab, event) {
        if (tab.name === '1') {
          this.selectTab = '1';
        } else if (tab.name === '0') {
          this.selectTab = '0';
        }
        let params = this.conputeXHRParams(1);
        this.loadList(params);
        this.$forceUpdate();
      },
      //改变页码时
      handleCurrentChange(val) {
        let params = this.conputeXHRParams(val);
        this.loadList(params);
        this.$forceUpdate();
      },
    },
    created() {
      let params = this.conputeXHRParams(1);
      this.loadList(params);
    },
    components: {}
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  .el-tabs__header
    margin: 0

  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 260px
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '~common/stylus/mixin.styl'
  .timetable
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    position relative
    .content-wrapper
      margin: 111px 20px 20px 180px
      width: 1050px
      .schedule-wrapper
        background: #fff
      .list-wrapper
        .list-item
          margin-bottom: 10px
          .item-top
            padding: 13px
            background: #fff
            overflow: hidden
            .lesson-img
              float: left
            .classinfo-wrapper
              float: left
              margin: 20px 0 0 20px
              .lesson-title
                height: 25px
                line-height: 25px
                font-size: 18px
                color: #333333
              .row
                margin-top: 10px
                font-size: 14px
                color: #888888
                height: 20px
                line-height: 20px

          .item-middle
            border-top: 1px solid #ccc
            height: 78px
            background: #fff
            line-height: 78px
            padding: 0 20px
            .item-middle-year
              font-size: 18px
              color: #333333
              height: 25px
            .item-middle-month
              margin-left: 15px
              font-size: 16px
              color: #333333
            .item-middle-catalogname
              margin-left: 40px
              font-size: 18px
              color: #333
            .item-middle-edit
              display: inline-block
              margin-left: 5px
              width: 20px
              height: 20px
              background: url('./edit.png') center / 20px
              cursor: pointer
              position: relative
              top: 3px
              &:hover
                background: url('./edit-hover.png') center / 20px

            .item-middle-btn
              float: right
              margin: 22px 0 0 0
              width: 120px
              height: 34px
              line-height: 34px
              font-size: 16px
              color: #fff
              padding-left: 18px
              background: #3399ff
              border-radius: 4px
              box-sizing: border-box
              text-align: left
              &::after
                content: ' ';
                display: inline-block;
                width: 8px;
                height: 8px;
                border-left: 1px solid #fff;
                border-bottom: 1px solid #fff;
                transform: rotate(-45deg);
                transition-duration: 300ms;
                float: right
                position: relative;
                top: 10px;
                right: 17px;
              &.show::after
                transform: rotate(135deg);
                position: relative;
                top: 15px;
                right: 17px;
              &:hover
                background: #2086ec
          .item-bottom
            border-top: 1px solid #ccc
            position: relative
            .item-bottom-switch-text
              display: inline-block
              position: absolute
              top: 135px
              right: 20px
              padding: 14px
              font-size: 16px
              color: #999
              cursor: pointer
              background: url('./right.png') no-repeat right center / 12px 12px
              &:before {
                content: ''
                position: absolute
                top: -10px
                left: -10px
                right: -10px
                bottom: -10px
                cursor: pointer
              }
              &:hover
                color: #3399ff
                background: url('./right-hover.png') no-repeat right center / 12px 12px
            .item-bottom-table-wrapper
              padding-top: 20px
              background: #fff
              .item-bottom-table-title
                margin-bottom: 30px
                margin-left: 20px
                font-size: 16px
                color: #333333
                height: 22px
                line-height: 22px
                padding-left: 14px
                font-weight: bold
                background: url('./deco.png') no-repeat left center / 4px 15px
              .item-bottom-table-free-row
                margin: 20px 0 0 20px
                height: 30px
                position: relative
                .left
                  display: inline-block
                  margin-right: 35px
                  line-height: 30px
                  font-size: 15px
                  color: #333
                  vertical-align: top
                .right
                  display: inline-block
                .text
                  display: inline-block
                  height: 30px
                  line-height: 30px
                  font-size: 14px
                  color: #333
                .select-week
                  display: inline-block
                  width: 260px
                  font-size: 14px
                  color: #ccc
                  border: 1px solid #e4e4e4
                  height: 30px
                  line-height: 30px
                  background: #fff url('down.png') no-repeat right 9px center
                  background-size: 12px 12px
                  padding: 0 30px 0 6px
                  border-radius: 4px
                  box-sizing: border-box
                  .weektext
                    float: left
                    color: #000
                .week-select-wrapper
                  display: inline-block
                  position: absolute
                  left: 100px
                  top: 41px
                  width: 333px
                  height: 120px
                  border: 1px solid #ccc
                  z-index: 10
                  background: #fff
                  .week-item
                    float: left
                    margin: 10px 0 10px 10px
                    width: 55px
                    height: 22px
                    line-height: 20px
                    text-align: center
                    font-size: 14px
                    color: #cccccc
                    border: 1px solid #cccccc
                    border-radius: 4px
                    box-sizing: border-box
                    cursor: pointer
                    &.now
                      background: #3399ff
                      line-height: 22px
                      color: #fff
                      border: none

                  .week-btn-wrapper
                    position: absolute
                    bottom: 20px
                    right: 10px
                    .week-cancel, .week-confirm
                      float: right
                      font-size: 14px
                      position: relative
                      &:before
                        content: ''
                        position: absolute
                        top: -4px
                        left: -4px
                        right: -4px
                        bottom: -4px
                    .week-cancel
                      color: #ccc
                      margin-right: 20px
                    .week-confirm
                      color: #3399ff
                .time-select-wrapper
                  display: inline-block
                  position: absolute
                  left: 100px
                  top: 0px
                  padding-left: 5px
                  width: 260px
                  height: 150px
                  border: 1px solid #ccc
                  z-index: 10
                  background: #fff
                  border-radius: 4px
                  box-sizing: border-box
                  .modify-number-wrapper {
                    float: left
                    margin: 16px 0 0 25px
                    width: 24px
                    .modify-number-icon {
                      display: inline-block
                      width: 24px
                      height: 24px
                      border-radius: 12px
                      cursor: pointer
                      &.minus {
                        background: #3399ff url('./minus.png') no-repeat center / 16px 16px
                      }
                      &.add {
                        background: #3399ff url('./add.png') no-repeat center / 16px 16px
                      }
                      &:hover {
                        background-color: #077cf2
                      }
                    }
                    .modify-number-number {
                      display: inline-block
                      width: 24px
                      text-align: center
                      margin: 4px 0
                      height: 28px
                      line-height: 28px
                      font-weight: bold
                      font-size: 20px
                      color: #3399ff
                    }
                  }
                  .result-number-wrapper {
                    float: left
                    margin: 20px 0 0 60px
                    width: 42px
                    .result-number-text {
                      display: inline-block
                      width: 42px
                      height: 20px
                      line-height: 20px
                      font-size: 14px
                      color: #999
                    }
                    .result-number-num {
                      display: inline-block
                      width: 24px
                      text-align: center
                      margin: 4px 0
                      height: 28px
                      line-height: 28px
                      font-weight: bold
                      font-size: 20px
                      color: #3399ff
                    }
                  }
                  .modify-number-btn-wrapper {
                    position: absolute
                    bottom: 10px
                    left: 75px
                    display: inline-block
                    width: 98px
                    height: 20px
                    font-size: 0
                    .modify-number-btn {
                      width: 44px
                      height: 20px
                      line-height: 20px
                      font-size: 14px
                      border-radius: 4px
                      color: #fff
                      &.cancel {
                        background #ccc
                      }
                      &.confirm {
                        margin-left: 10px
                        background #3399ff
                      }
                    }

                  }
              .operate-btn-wrapper
                margin: 35px 0 0 120px
                padding-bottom: 30px
                .btn
                  width: 100px
                  height: 30px
                  line-height: 30px
                  font-size: 14px
                  color: #ffffff
                .cancel
                  background #ccc
                .confirm
                  margin-left: 30px
                  background #3399ff

          .item-hint
            padding: 20px 0 10px 0
            font-size: 14px
            color: #888
            .color
              color: #3399ff
        .empty-wrapper {
          height: 560px
          padding-top: 110px
          text-align: center
          background: #fff
          box-sizing: border-box
          .empty-hint-text {
            margin-top: 10px
            height: 22px
            line-height: 22px
            font-size: 16px
            color: #a5a5a5
            &.free:hover {
              cursor: pointer
              color: #3399ff
            }
          }
        }


</style>



// WEBPACK FOOTER //
// src/page/calendarlist/changeschooltime/ChangeSchoolTime.vue